var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
import { createDateObject, formatDate, toHumanFormat } from '~/tools/date/date';
export class ModelBook {
    cdate;
    coverLink;
    eventId;
    fperiod;
    id;
    isPublic;
    lastNotificationSent;
    mdate;
    name;
    objId;
    objName;
    order;
    ownerId;
    relativeId;
    shelveId;
    skin;
    speriod;
    srcCollectionId;
    syncAllowShare;
    syncId;
    type;
    userId;
    period;
    sYear;
    fYear;
    formattedCDate;
    ownerName;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "cdate", void 0);
__decorate([
    Expose({ name: 'cover_link' }),
    __metadata("design:type", Object)
], ModelBook.prototype, "coverLink", void 0);
__decorate([
    Expose({ name: 'event_id' }),
    __metadata("design:type", String)
], ModelBook.prototype, "eventId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelBook.prototype, "fperiod", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "id", void 0);
__decorate([
    Expose({ name: 'is_public' }),
    __metadata("design:type", String)
], ModelBook.prototype, "isPublic", void 0);
__decorate([
    Expose({ name: 'last_notification_sent' }),
    __metadata("design:type", Object)
], ModelBook.prototype, "lastNotificationSent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "mdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "name", void 0);
__decorate([
    Expose({ name: 'obj_id' }),
    __metadata("design:type", String)
], ModelBook.prototype, "objId", void 0);
__decorate([
    Expose({ name: 'obj_name' }),
    __metadata("design:type", String)
], ModelBook.prototype, "objName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "order", void 0);
__decorate([
    Expose({ name: 'owner_id' }),
    __metadata("design:type", Object)
], ModelBook.prototype, "ownerId", void 0);
__decorate([
    Expose({ name: 'relative_id' }),
    __metadata("design:type", Object)
], ModelBook.prototype, "relativeId", void 0);
__decorate([
    Expose({ name: 'shelf_id' }),
    __metadata("design:type", Object)
], ModelBook.prototype, "shelveId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "skin", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "speriod", void 0);
__decorate([
    Expose({ name: 'src_collection_id' }),
    __metadata("design:type", String)
], ModelBook.prototype, "srcCollectionId", void 0);
__decorate([
    Expose({ name: 'sync_allow_share' }),
    __metadata("design:type", String)
], ModelBook.prototype, "syncAllowShare", void 0);
__decorate([
    Expose({ name: 'sync_id' }),
    __metadata("design:type", Object)
], ModelBook.prototype, "syncId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "type", void 0);
__decorate([
    Expose({ name: 'user_id' }),
    __metadata("design:type", String)
], ModelBook.prototype, "userId", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => {
        const sPeriod = toHumanFormat(obj.speriod);
        const fPeriod = toHumanFormat(obj.fperiod);
        return `${sPeriod || ''}${sPeriod && fPeriod ? ' - ' : ''}${fPeriod || ''}`;
    }),
    __metadata("design:type", String)
], ModelBook.prototype, "period", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => {
        const startDate = createDateObject(obj.speriod);
        if (!startDate) {
            return null;
        }
        return startDate.getFullYear();
    }),
    __metadata("design:type", Object)
], ModelBook.prototype, "sYear", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => {
        const endDate = createDateObject(obj.fperiod);
        if (!endDate) {
            return null;
        }
        return endDate.getFullYear();
    }),
    __metadata("design:type", Object)
], ModelBook.prototype, "fYear", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => formatDate(obj.cdate)),
    __metadata("design:type", Object)
], ModelBook.prototype, "formattedCDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelBook.prototype, "ownerName", void 0);
